var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-page bold tablec" }, [
    _c(
      "div",
      { staticClass: "d-flex flex-row" },
      [
        _c(
          "Widget",
          {
            staticClass: "w-100",
            attrs: { title: "Leaderboard", "fetching-data": _vm.isReceiving }
          },
          [
            _c(
              "div",
              { staticClass: "w-25 float-right mb-3" },
              [
                _c("v-select", {
                  attrs: {
                    id: "search-select",
                    options: _vm.leaderboardBehaviours
                  },
                  on: { input: _vm.onBehaviourSelect },
                  model: {
                    value: _vm.selectedBehaviour,
                    callback: function($$v) {
                      _vm.selectedBehaviour = $$v
                    },
                    expression: "selectedBehaviour"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.leaderboard && _vm.leaderboard.length > 0
              ? _c(
                  "div",
                  { staticClass: "table-resposive" },
                  [
                    _vm.selectedBehaviour.id == null
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mb-4 mt-3",
                            attrs: { variant: "success" },
                            on: {
                              click: function($event) {
                                return _vm.refreshGeneralLeaderboard(
                                  _vm.$toasted
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    Refresh general leaderboard\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasAdminRole()
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "abc-checkbox abc-checkbox-primary mb-4"
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.selectedCountry.allowGlobalVisibility,
                                  expression:
                                    "selectedCountry.allowGlobalVisibility"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "allowGlobalVisibility"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.selectedCountry.allowGlobalVisibility
                                )
                                  ? _vm._i(
                                      _vm.selectedCountry.allowGlobalVisibility,
                                      null
                                    ) > -1
                                  : _vm.selectedCountry.allowGlobalVisibility
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a =
                                        _vm.selectedCountry
                                          .allowGlobalVisibility,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.selectedCountry,
                                            "allowGlobalVisibility",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.selectedCountry,
                                            "allowGlobalVisibility",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.selectedCountry,
                                        "allowGlobalVisibility",
                                        $$c
                                      )
                                    }
                                  },
                                  function($event) {
                                    return _vm.toggleAllowGlobalVisibility()
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "allowGlobalVisibility" } },
                              [_vm._v("Allow global visibility")]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { staticClass: "hidden-sm-down" }, [
                            _vm._v("#")
                          ]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Full name")]),
                          _vm._v(" "),
                          _c("th", { staticClass: "hidden-sm-down" }, [
                            _vm._v("Stars")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.leaderboard, function(row, i) {
                          return _c("tr", { key: row.id }, [
                            _c("td", [_vm._v(_vm._s(row.place))]),
                            _vm._v(" "),
                            _c("td", [
                              row.avatarUrl
                                ? _c("img", {
                                    staticClass:
                                      "profileAvatar rounded-circle mr-2",
                                    staticStyle: {
                                      "vertical-align": "middle",
                                      width: "50px",
                                      height: "50px",
                                      "border-radius": "50%"
                                    },
                                    attrs: { src: row.avatarUrl, alt: "..." }
                                  })
                                : _c("img", {
                                    staticClass:
                                      "profileAvatar rounded-circle mr-2",
                                    staticStyle: {
                                      "vertical-align": "middle",
                                      width: "50px",
                                      height: "50px",
                                      "border-radius": "50%"
                                    },
                                    attrs: {
                                      src: require("../../assets/people/default_avatar.png"),
                                      alt: "..."
                                    }
                                  }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(row.fullName) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-semi-muted" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(Math.round(row.score * 100) / 100) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "width-150" },
                              [
                                _c("b-progress", {
                                  staticClass: "progress-sm mb-xs",
                                  attrs: {
                                    variant: "success",
                                    value: row.score,
                                    max: _vm.leaderboard[0].score
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              : _c("h5", { staticClass: "pt-4" }, [
                  _vm._v(" No scores registered yet!")
                ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }